module.exports = __webpack_public_path__ + "static/logo-libbet-d52753494e97953b0980f7cc4388a6fb.png";